import { AutogenLayoutPayeeForWireFundsLookup } from "./autogen/AutogenLayoutPayeeForWireFundsLookup";

export class PayeeForWireFundsLookup extends AutogenLayoutPayeeForWireFundsLookup {
}
